import { api } from '@api/api2';

export const getKeyTypes = () =>
  api.no_vers('get', 'script/universal-types', { type: 'key_type' });
